<template>
  <card class="col-md-7 d-none d-md-block" v-if="show">
    <!-- <button @click="test">test</button> -->
    <h5 class="text-center"><i class="nc-icon nc-globe"></i> INTEGRACIONES</h5>
    <h6 class="mb-1 mt-4">BSALE</h6>
    <hr class="mt-0" />
    <div class="d-flex flex-row">
      <p class="my-auto mr-4 col-3 text-nowrap">
        {{
          showingData.BSALE.INDICADOR_ACTIVA_BSALE
            ? "HABILITADO"
            : "DESHABILITADO"
        }}
      </p>
      <p-switch
        type="success"
        class="my-auto"
        size="small"
        :disabled="!edit"
        v-model="showingData.BSALE.INDICADOR_ACTIVA_BSALE"
        offText="OFF"
        onText="ON"
      ></p-switch>
    </div>
    <p class="border-bottom col-3 pl-0 mt-3">Codigos</p>
    <div class="col-12 px-0 d-flex flex-row flex-wrap">
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_OFICINA"
          />
        </div>
        <p class="my-auto">Oficina</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_LISTA_PRECIO"
          />
        </div>
        <p class="my-auto text-nowrap">Lista Precio</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_IMP_IVA"
          />
        </div>
        <p class="my-auto text-nowrap">IVA</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_IMP_EXCENTO"
          />
        </div>
        <p class="my-auto text-nowrap">Imp Excento</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_MP_EFECTIVO"
          />
        </div>
        <p class="my-auto text-nowrap">MP Efectivo</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_MP_DEBITO"
          />
        </div>
        <p class="my-auto text-nowrap">MP Debito</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_MP_CREDITO"
          />
        </div>
        <p class="my-auto text-nowrap">MP Credito</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_MP_CHEQUE"
          />
        </div>
        <p class="my-auto text-nowrap">MP Cheque</p>
      </div>
      <div class="col-6 d-flex flex-row px-0 mb-2">
        <div class="my-auto col-4 mr-2 px-0">
          <input
            type="number"
            class="form-control"
            :disabled="!edit"
            v-model.number="showingData.BSALE.CODIGOS.ID_MP_TRANSFERENCIA"
          />
        </div>
        <p class="my-auto text-nowrap">MP Transferencia</p>
      </div>
    </div>
    <div class="d-flex flex-row flex-wrap">
      <div class="col-12 col-md-6">
        <p class="border-bottom col-5 pl-0 mt-3">Token</p>
        <input
          type="text"
          class="form-control"
          :disabled="!edit"
          v-model.trim="showingData.BSALE.TOKEN_BSALE"
        />
      </div>
      <div class="col-12 col-md-6">
        <p class="border-bottom col-5 pl-0 mt-3 text-nowrap">URL Base</p>
        <input
          type="text"
          class="form-control"
          :disabled="!edit"
          v-model.trim="showingData.BSALE.URL_BSALE_API"
        />
      </div>
    </div>
    <div class="d-flex flex-row mt-4">
      <h5 class="my-auto text-nowrap">
        <i class="nc-icon nc-money-coins"></i>
        PASARELAS DE PAGO
      </h5>
      <small
        v-if="showingData.HABILITAR_PLATAFORMAS_DE_PAGO"
        class="bg-success py-1 px-2 rounded-pill text-light my-auto ml-2"
        >HABILITADAS</small
      >
      <small
        v-else
        class="bg-danger py-1 px-2 rounded-pill text-light my-auto ml-2"
        >DESHABILITADAS</small
      >
      <p-switch
        type="success"
        class="my-auto mr-2 ml-auto"
        size="small"
        v-model="showingData.HABILITAR_PLATAFORMAS_DE_PAGO"
        :disabled="!edit"
        offText="OFF"
        onText="ON"
      ></p-switch>
    </div>
    <hr class="" />
    <h6 class="mb-1 mt-4 border-bottom col-2">FLOW</h6>
    <div class="d-flex flex-row">
      <p class="my-auto col-auto text-nowrap">
        Plataforma
        <span
          class="py-1 px-2 text-light rounded-pill"
          :class="showingData.FLOW.HABILITADA ? `bg-success` : `bg-danger`"
          >{{
            showingData.FLOW.HABILITADA ? "habilitada" : "deshabilitada"
          }}</span
        >
      </p>

      <p-switch
        type="success"
        class="my-auto"
        size="small"
        v-model="showingData.FLOW.HABILITADA"
        :disabled="!edit"
        offText="OFF"
        onText="ON"
      ></p-switch>
    </div>
    <div class="d-flex flex-row flex-wrap">
      <div class="col-12 col-md-6">
        <p class="border-bottom col-5 pl-0 mt-3">API Key</p>
        <input
          type="text"
          class="form-control"
          :disabled="!edit"
          v-model.trim="showingData.FLOW.API_KEY"
        />
      </div>
      <div class="col-12 col-md-6">
        <p class="border-bottom col-5 pl-0 mt-3 text-nowrap">Secret Key</p>
        <input
          type="text"
          class="form-control"
          :disabled="!edit"
          v-model.trim="showingData.FLOW.SECRET_KEY"
        />
      </div>
      <div class="col-12 col-md-6">
        <p class="border-bottom col-5 pl-0 mt-3 text-nowrap">URL Base</p>
        <input
          type="text"
          class="form-control"
          :disabled="!edit"
          v-model.trim="showingData.FLOW.URL_API"
        />
      </div>
    </div>
    <div class="col-12 d-flex flex-row justify-content-center py-2">
      <button
        v-if="!edit"
        class="btn btn-info mx-auto"
        @click="toggleEdit(true)"
      >
        editar
      </button>
      <template v-else>
        <button class="btn btn-success mr-4" @click="handleSave()">
          guardar
        </button>
        <button class="btn btn-danger" @click="toggleEdit(false)">
          CANCELAR
        </button>
      </template>
    </div>
  </card>
</template>

<script>
import _ from "lodash";
import Dropdown from "src/components/UIComponents/Dropdown.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { stat } from "fs";
import { type } from "os";
export default {
  components: {
    PSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  props: {
    TRXTypes: {
      type: Array,
      default: () => {
        return ["[BOLETA ELECTRÓNICA]", "[COMPROBANTE DE VENTA]"];
      },
    },
  },
  data() {
    return {
      edit: false,
      show: false,
      showingData: {
        BSALE: {
          CODIGOS: {
            ID_OFICINA: 3,
            ID_LISTA_PRECIO: 227,
            ID_IMP_IVA: 1,
            ID_IMP_EXCENTO: 0,
            ID_MP_EFECTIVO: 1,
            ID_MP_DEBITO: 6,
            ID_MP_CREDITO: 2,
            ID_MP_CHEQUE: 5,
            ID_MP_TRANSFERENCIA: 8,
          },
          INDICADOR_ACTIVA_BSALE: false,
          TOKEN_BSALE: "",
          URL_BSALE_API: "",
        },
        FLOW: {
          API_KEY: "",
          SECRET_KEY: "",
          PLATAFORMA_DE_PAGO: true,
          HABILITADA: false,
          URL_API: "https://sandbox.flow.cl/api",
        },
        HABILITAR_PLATAFORMAS_DE_PAGO: false,
      },
      dataOG: {},
    };
  },
  watch: {},
  methods: {
    test() {
      console.log(this.showingData.BSALE.CODIGOS);
    },
    toggleEdit(state) {
      this.edit = state;
      if (state) {
        this.dataOG = _.cloneDeep(this.showingData);
      } else {
        this.showingData = _.cloneDeep(this.dataOG);
      }
    },
    handleSave() {
      const newData = _.cloneDeep(this.showingData);
      this.$emit("saveIntegrationChanges", newData);
    },
    start(data) {
      let configData = data;
      if (!configData.BSALE) {
        // console.log("nodo bsale");
        configData.BSALE = {
          CODIGOS: {
            ID_OFICINA: 3,
            ID_LISTA_PRECIO: 227,
            ID_IMP_IVA: 1,
            ID_IMP_EXCENTO: 0,
            ID_MP_EFECTIVO: 1,
            ID_MP_DEBITO: 6,
            ID_MP_CREDITO: 2,
            ID_MP_CHEQUE: 5,
            ID_MP_TRANSFERENCIA: 8,
          },
          INDICADOR_ACTIVA_BSALE: false,
          TOKEN_BSALE: "",
          URL_BSALE_API: "",
        };
      }
      if (!configData.FLOW) {
        // console.log("nodo flow");
        configData.FLOW = {
          API_KEY: "",
          SECRET_KEY: "",
          PLATAFORMA_DE_PAGO: true,
          HABILITADA: false,
          URL_API: "https://sandbox.flow.cl/api",
        };
      }
      if (typeof configData.HABILITAR_PLATAFORMAS_DE_PAGO === "undefined") {
        // console.log("habilitar plataformas de pago");
        configData.HABILITAR_PLATAFORMAS_DE_PAGO = false;
      }

      this.showingData = _.cloneDeep(configData);
      this.show = true;

      // console.log("this.showingData");
      // console.log(this.showingData);
    },
    close() {
      this.show = false;
      this.edit = false;
      this.showingData = {
        BSALE: {
          CODIGOS: {
            ID_OFICINA: 3,
            ID_LISTA_PRECIO: 227,
            ID_IMP_IVA: 1,
            ID_IMP_EXCENTO: 0,
            ID_MP_EFECTIVO: 1,
            ID_MP_DEBITO: 6,
            ID_MP_CREDITO: 2,
            ID_MP_CHEQUE: 5,
            ID_MP_TRANSFERENCIA: 8,
          },
          INDICADOR_ACTIVA_BSALE: false,
          TOKEN_BSALE: "",
          URL_BSALE_API: "",
        },
        FLOW: {
          API_KEY: "",
          SECRET_KEY: "",
          PLATAFORMA_DE_PAGO: true,
          HABILITADA: false,
          URL_API: "https://sandbox.flow.cl/api",
        },
        HABILITAR_PLATAFORMAS_DE_PAGO: false,
      };
    },
  },
};
</script>

<style></style>
